// extracted by mini-css-extract-plugin
export default {"detailViewContainer":"detailCellRenderer_detailViewContainer__Maoy5"};